import { createAsyncThunk } from "@reduxjs/toolkit";
import { convertSubAccountRoleResponseToAccountAttempt } from "./utils/helpers/convertSubAccountRoleResponseToAccountAttempt";
import {
  cloudChiprApi,
  ProviderAccessType,
} from "../../../services/cloudchipr.api";
import { allAccountsGroupedByProviderSelector } from "../../accounts/selectors/all-providers/allAccountsGroupedByProviderSelector";
import { RootState } from "../../store";
import { providerAccessTypeSelector } from "../selectors/providerAccessTypeSelector";
import { goToNextStep, setAccountAttempt } from "../accountSetupSlice";

interface CreateAwsAccountsSubAccountRolesByIdThunkARgs {
  accountId: string;
  accessType: ProviderAccessType;
}
export const createAwsAccountsSubAccountRolesByIdThunk = createAsyncThunk(
  "accountSetup/createAwsAccountsSubAccountRolesById",
  async (
    { accountId, accessType }: CreateAwsAccountsSubAccountRolesByIdThunkARgs,
    { dispatch, getState },
  ) => {
    const { postUsersMeProvidersAwsSubAccountsByAccountId } =
      cloudChiprApi.endpoints;
    const state = getState() as RootState;

    const result = await dispatch(
      postUsersMeProvidersAwsSubAccountsByAccountId.initiate({
        accountId,
        body: {
          access_type: accessType,
        },
      }),
    ).unwrap();

    if (result) {
      const accounts = allAccountsGroupedByProviderSelector(state);
      const accessType = providerAccessTypeSelector(state);

      if (accounts && accessType) {
        const accountAttempt = convertSubAccountRoleResponseToAccountAttempt({
          accounts,
          accessType,
          accountId,
          subAccountRole: result,
        });
        if (accountAttempt) {
          dispatch(setAccountAttempt(accountAttempt));
          dispatch(goToNextStep());
        }
      }
    }
  },
);
